import { objectToGetParams } from "@utils/link";
import { WhatsappService } from "./whatsappService";

export class BrowserWhatsappService implements WhatsappService {
	async openShareDialog(url: string, text: string): Promise<void> {
		return new Promise(function () {
			window.open(
				"https://wa.me/" +
					objectToGetParams({
						text: text ? text + " " + url : url,
					})
			);
		});
	}
}
